import { styled, Typography } from "@mui/material";

export const TitleContainer = styled(Typography)(() => ({
  lineHeight: "1.375rem",
  marginBottom: "0.313rem",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));
